/* v8 ignore file -- @preserve */

export interface ImportOptions {
  name: string; // Package name
  path?: string; // Path to import within the package
  version?: string;
}

const DefaultProperty = 'default';

export function importFromEsmSh<T>(options: ImportOptions, property?: string): Promise<T> {
  return importFromUrl(`https://esm.sh/${buildImport(options)}`, property);
}

export function importFromJsdelivr<T>(options: ImportOptions, property?: string): Promise<T> {
  return importFromUrl(`https://cdn.jsdelivr.net/npm/${buildImport(options)}/+esm`, property);
}

async function importFromUrl<T>(url: string, property = DefaultProperty): Promise<T> {
  // Note: must use @vite-ignore in import; see https://github.com/vitejs/vite/issues/3378
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
  return (await import(/* @vite-ignore */ url))[property];
}

function buildImport({name, path, version}: ImportOptions): string {
  const atVersion = normalizeVersion(version);
  const normalizedPath = normalizePath(path);
  return `${name}${atVersion}${normalizedPath}`;
}

function normalizeVersion(version?: string) {
  if (!version) {
    return '';
  }
  return `@${version}`;
}

function normalizePath(path?: string) {
  if (!path) {
    return path;
  }

  const normalized = path;

  // Remove trailing slash, if any:
  if (normalized.endsWith('/')) {
    normalized.slice(0, normalized.length - 1);
  }

  // Path must begin with slash:
  if (normalized.startsWith('/')) {
    return normalized;
  }

  return `/${normalized}`;
}
